import { EntityEventType } from '@racemap/sdk/schema/entityEvents';

export const criticalAlertEventTypes = new Set<EntityEventType>([
  EntityEventType.CRASH,
  EntityEventType.SOS,
]);

export const infoAlertEventTypes = new Set<EntityEventType>([
  EntityEventType.NO_MOVEMENT,
  EntityEventType.POWER_OFF,
  EntityEventType.AWAY_FROM_TRACK,
  EntityEventType.LOW_BATTERY,
  EntityEventType.MOVEMENT,
]);

export const basicAlertEventTypes = new Set<EntityEventType>([
  ...criticalAlertEventTypes,
  ...infoAlertEventTypes,
]);

export type EventCategory = 'alerts' | 'notifications';
export const getEventCategory = (t: EntityEventType): EventCategory =>
  criticalAlertEventTypes.has(t) ? 'alerts' : 'notifications';
